import { render, staticRenderFns } from "./VistaNoticia.vue?vue&type=template&id=5a6335a9&scoped=true"
import script from "./VistaNoticia.vue?vue&type=script&lang=js"
export * from "./VistaNoticia.vue?vue&type=script&lang=js"
import style0 from "./VistaNoticia.vue?vue&type=style&index=0&id=5a6335a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6335a9",
  null
  
)

export default component.exports